<template>
    <div class="my-6 w-[100%] flex flex-col justify-center place-self-center">
        <h2 class="text-center font-bold md:text-2xl my-5 text-lg text-GRIS_LEON">Conoce nuestros servicios</h2>
        <div class="px-4 h-[33rem] md:h-auto flex flex-row overflow-x-auto md:grid md:grid-cols-3 gap-2 md:gap-5 max-w-[1300px] md:mx-auto mx-[20px] py-3 conoce-container">
            <CardServicio 
                v-for="(card, index) in cardData" 
                :key="index" 
                :data="card"
                class="w-[85%] md:w-auto flex-shrink-0"
            /> 
        </div>
    </div>
</template>

<script setup>
import CardServicio from '~/components/Cards/CardServicio.vue';

const cardData = [
  {
    title: 'Red de Asociados LEÓN',
    description: 'A través de nuestra Red de Asociados, los clientes pueden acceder a inspecciones y servicios confiables en distintos puntos del país, respaldados por la experiencia y el sello de excelencia de LEÓN.',
    link: '/asociados',
    buttonText: 'Conocer red de asociados',

    cont_padre: 'flex-col',
    tam_imagen_1: 'h-[42%] md:h-[50%] aspect-square',
    cont_inferior: 'text-center items-center h-[58%] md:h-[50%] justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',

    displayLeon: false,
    image: '/img/newhome/conoce-servicios/asociados_1.webp',
    backgroundimage:'/img/newhome/conoce-servicios/reparacion.webp',
  },
  {
    title: 'Revisión Técnica',
    description: 'En LEÓN realizamos una revisión preventiva completa de tu vehículo, detectando posibles fallas que podrían impedir la aprobación. Nuestro servicio te ayuda a evitar rechazos y a cumplir con la normativa vigente, asegurando un proceso rápido y sin contratiempos.',
    link: '/revision-tecnica',
    buttonText: 'Ir a revisión técnica',

    cont_padre: 'flex-col',
    tam_imagen_1: 'h-[42%] md:h-[50%] aspect-square',
    cont_inferior: 'text-center items-center h-[58%] md:h-[50%] justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',

    displayLeon: false,
    image: '/img/newhome/conoce-servicios/asociados_2.webp',
    backgroundimage:'/img/newhome/conoce-servicios/chequeo.webp',
  },
  {
    title: 'Mantención de Kilometraje',
    description: 'Realizamos mantenciones programadas según el kilometraje recomendado por el fabricante, utilizando repuestos de calidad y técnicos certificados. Prolonga la vida útil de tu vehículo y maneja con tranquilidad, sabiendo que estás al día.',
    link: 'https://mantenciondekilometraje.leon.cl',
    buttonText: 'Ir a mantención de kilometraje',

    cont_padre: 'flex-col',
    tam_imagen_1: 'h-[42%] md:h-[50%] aspect-square',
    cont_inferior: 'text-center items-center h-[58%] md:h-[50%] justify-between',
    estilo_boton_link: 'bg-white border-ROJO_LEON text-ROJO_LEON',

    displayLeon: false,
    image: '/img/newhome/conoce-servicios/asociados_3.webp',
    backgroundimage:'/img/newhome/conoce-servicios/volante.webp',
  }
];

</script>

<style scoped>

.conoce-container{
  scrollbar-width: none;  
  -ms-overflow-style: none;    
  overflow: auto;              
}

/* Chrome, Edge, Safari */
.conoce-container::-webkit-scrollbar {
  display: none;
}

</style>